goog.provide("shadow.js.shim.module$$mui$material$Link");
goog.provide("module$shadow_js_shim_module$$mui$material$Link");
shadow.js.shim.module$$mui$material$Link = shadow.js.nativeProvides["@mui/material/Link"] = shadow$bridge("@mui/material/Link");
module$shadow_js_shim_module$$mui$material$Link.default = shadow.js.shim.module$$mui$material$Link;
